import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0) { return { "spinner-border-sm": a0 }; };
class LoadingComponent {
    constructor() {
        this.size = 'medium';
    }
    ngOnInit() { }
}
LoadingComponent.ɵfac = function LoadingComponent_Factory(t) { return new (t || LoadingComponent)(); };
LoadingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoadingComponent, selectors: [["fgbcl-loading"]], inputs: { size: "size" }, decls: 4, vars: 3, consts: [[1, "text-center"], ["role", "status", 1, "spinner-border", 3, "ngClass"], [1, "sr-only"]], template: function LoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3, "Loading...");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx.size === "small"));
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
LoadingComponent.propDecorators = {
    size: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-loading',
                template: "<div class=\"text-center\">\r\n  <div class=\"spinner-border\" [ngClass]=\"{ 'spinner-border-sm': size === 'small' }\" role=\"status\">\r\n    <span class=\"sr-only\">Loading...</span>\r\n  </div>\r\n</div>\r\n"
            }]
    }], function () { return []; }, { size: [{
            type: Input
        }] }); })();

class LoadingModule {
}
LoadingModule.ɵfac = function LoadingModule_Factory(t) { return new (t || LoadingModule)(); };
LoadingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LoadingModule });
LoadingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoadingModule, { declarations: function () { return [LoadingComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LoadingComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingModule, [{
        type: NgModule,
        args: [{
                declarations: [LoadingComponent],
                imports: [CommonModule],
                exports: [LoadingComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingComponent, LoadingModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-loading.js.map